import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import {
  CreditMemoSearchCriteria,
  CustomerSearchCriteria,
  InvoiceSearchCriteria,
  PageListBean,
  RestCreditMemoBeanRequest,
  RestCustomerListRequest,
  RestInvoiceListRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { InvoiceLookupHandlers } from "../lookup/InvoiceLookupHandlers.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { CreditMemoService } from "../services/CreditMemoService.js";
import { CustomerService } from "../services/CustomerService.js";
import { InvoiceService } from "../services/InvoiceService.js";
export class CreditMemoLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    let resetCriteria = new CreditMemoSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new CreditMemoSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let creditMemoLookupCriteria = new CreditMemoSearchCriteria();
    creditMemoLookupCriteria.companyCode = this.companyCode;
    let lookupCriteriaView = CreditMemoLookupCriteraHandler(
      companyCode,
      creditMemoLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      creditMemoLookupCriteria,
      lookupCriteriaView
    );
    ModuleUtils.getCreditMemoStatusList();
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition(" Name", "customerCode", 0, false); //1
    this.addColumnDefinition(" CustomerName", "customerName", 0, false); //1
    this.addColumnDefinition(" CreditType", "creditType", 0, false);
    this.addColumnDefinition(" Invoice", "invoiceNumber", 0, false);
    this.addColumnDefinition(" CMDate", "creditMemoDate", 0, false);
    this.addColumnDefinition(" Currency", "customerCurrencyCode", 0, false);
    this.addColumnDefinition(" CreditAmt", "totalCreditAmount", 1, false);
    this.addColumnDefinition(" AppliedAmt", "appliedAmount", 1, false);
    this.addColumnDefinition(" Status", "creditMemoStatus", 0, false);
  }
  loadCreditMemoList = (lookup_dialog, pageNumber, searchCriteria) => {
    let criteria = new CreditMemoSearchCriteria(); //To be fetched from CriteriaHandler
    criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      criteria.creditMemoNumberStartsWith =
        searchCriteria.creditMemoNumberStartsWith;
      criteria.creditMemoNumberContains =
        searchCriteria.creditMemoNumberContains;
      criteria.creditMemoStatus = searchCriteria.creditMemoStatus;
      criteria.customerCode = searchCriteria.customerCode;
      criteria.invoiceNumber = searchCriteria.invoiceNumber;
    }
    let pageList = new PageListBean();
    pageList.pageSize = 50; //TODO --> Fetch from Config
    pageList.currentPage = pageNumber;
    pageList.pageNumber = pageNumber;
    let requestInput = new RestCreditMemoBeanRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    CreditMemoService.getCreditMemoPageList(
      requestInput,
      (response) => this.loadCreditMemoListResponse(response, lookup_dialog),
      this.loadCreditMemoListError
    );
  };
  loadCreditMemoListResponse = (response, lookup_dialog) => {
    let creditMemoList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.creditMemoPageList != null &&
      response.data.creditMemoPageList.creditMemos !== null
    ) {
      creditMemoList = response.data.creditMemoPageList.creditMemos;
      totalCount = response.data.creditMemoPageList.totalCount;
      currentPageNumber = response.data.creditMemoPageList.currentPage;
      pageSize = response.data.creditMemoPageList.pageSize;
      creditMemoList.map((cm) => {
        cm.creditMemoStatus = ModuleUtils.getCreditMemoStatusCaption(
          cm.creditMemoStatus
        );
      });
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = creditMemoList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadCreditMemoListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.creditMemoNumberContains)) {
      if (!isEmptyString(filterText)) {
        search.creditMemoNumberContains = filterText;
        this.searchCriteria = new CreditMemoSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadCreditMemoList(lookup_dialog, pageNumber, search);
    }
  }
}
const CreditMemoLookupCriteraHandler = (
  companyCode,
  creditMemoLookupCriteria
) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new CreditMemoSearchCriteria(),
        customerPageListForAutoCompleteList: new Array(),
        showAutoCompleteCustomerList: true,
        invoicePageListForAutoCompleteList: new Array(),
        showAutoCompleteInvoiceList: true,
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
      this.initLookupHandlers();
    }
    initLookupHandlers = () => {
      let customerLookupHandler = new CustomerLookupHandler(
        companyCode,
        "Customer"
      );
      this.setState({ customerLookupHandler: customerLookupHandler });

      let invoiceLookupHandler = new InvoiceLookupHandlers(
        companyCode,
        "invoiceNumber"
      );
      this.setState({ invoiceLookupHandler: invoiceLookupHandler });
    };
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;

      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new CreditMemoSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    customerCodeOnChange = (e) => {
      let customerCode = e.target.value;
      this.state.showAutoCompleteCustomerList = true;
      let tempCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      if (isEmpty(customerCode)) {
        this.state.showAutoCompleteCustomerList = false;
        let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
        let criteria = this.state.searchCriteria;
        criteria.customerCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteCustomerList: showAutoCompleteList,
          searchCriteria: criteria,
          customerPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "customerCode" &&
        showAutoCompleteList === true &&
        customerCode !== ""
      ) {
        this.readCustomerBySearchString(e.target.value);
      }
      tempCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: tempCriteria });
    };
    readCustomer = (customerCode) => {
      let input = new RestReadRequest();
      input.companyCode = companyCode;
      input.code = customerCode;
      input.isLoadChildren = true;
      CustomerService.readCustomer(
        input,
        this.editCustomerResponse,
        this.errorCallBack
      );
    };
    editCustomerResponse = (response) => {
      if (response.data.customer != null) {
        let customerData = response.data.customer;
        let criteria = this.state.searchCriteria;
        criteria.customerCode = customerData.code;
        criteria.customerName = customerData.description;
        this.setState({ searchCriteria: criteria });
      }
    };
    readCustomerBySearchString(searchString) {
      let searchCriteria = new CustomerSearchCriteria();
      searchCriteria.companyCode = companyCode;
      searchCriteria.customerCodeStartsWith = searchString;
      searchCriteria.customerNameContains = searchString;
      let cust_pageList = new RestPageListBean();
      cust_pageList.pageSize = 100;
      let cust_requestInput = new RestCustomerListRequest();
      cust_requestInput.pageInput = cust_pageList;
      cust_requestInput.searchCriteria = searchCriteria;
      CustomerService.getCustomerPageList(
        cust_requestInput,
        this.readByCustomerCodeResponse,
        this.errorCallBack
      );
    }
    readByCustomerCodeResponse = (response) => {
      let customerData = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    };
    customerCodeEnterKeyEventHandler = (e) => {
      let customerCode = e.target.value;
      this.readCustomer(customerCode);
      this.setState({
        customerPageListForAutoCompleteList: new Array(),
      });
    };
    displayAutoCompleteList = (showAutoCompleteList) => {
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
      });
    };
    errorCallBack = (error) => {
      ShowError(error);
    };

    invoiceOnChange = (e) => {
      let criteria = this.state.searchCriteria;
      let invoiceNumber = e.target.value;
      this.state.showAutoCompleteInvoiceList = true;
      let showAutoCompleteInvoiceList = this.state.showAutoCompleteInvoiceList;
      if (isEmpty(invoiceNumber)) {
        let criteria = this.state.searchCriteria;
        criteria.invoiceNumber = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteInvoiceList: false,
          searchCriteria: criteria,
          invoicePageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "invoiceNumber" &&
        showAutoCompleteInvoiceList === true &&
        invoiceNumber !== ""
      ) {
        this.readapplyInvoiceBySearchString(e.target.value);
      }
      criteria[e.target.name] = e.target.value.toUpperCase();
      this.setState({ searchCriteria: criteria });
    };
    invoiceEnterKeyEvent = (e) => {
      let invoiceNumber = e.target.value;
      let invoiceCriteria = this.state.searchCriteria;
      invoiceCriteria.invoiceNumber = invoiceNumber;
      this.setState({
        invoicePageListForAutoCompleteList: new Array(),
        showAutoCompleteInvoiceList: false,
        searchCriteria: invoiceCriteria,
      });
    };
    displayInvoiceAutoCompleteList = (showAutoCompleteList) => {
      this.setState({
        showAutoCompleteInvoiceList: showAutoCompleteList,
      });
    };
    readapplyInvoiceBySearchString = (searchString) => {
      let inv_criteria = new InvoiceSearchCriteria();
      inv_criteria.invoiceNumberStartsWith = searchString;
      inv_criteria.invoiceNumberContains = searchString;
      let inv_pageList = new RestPageListBean();
      inv_pageList.pageSize = 100;
      let inv_requestInput = new RestInvoiceListRequest();
      inv_requestInput.pageInput = inv_pageList;
      inv_requestInput.searchCriteria = inv_criteria;
      InvoiceService.getInvoicePageList(
        inv_requestInput,
        this.loadApplyInvoicesResponse,
        this.errorCallBack
      );
    };
    loadApplyInvoicesResponse = (response) => {
      if (
        !isEmpty(response.data) &&
        !isEmpty(response.data.invoicePageList) &&
        !isEmptyArray(response.data.invoicePageList.invoices)
      ) {
        let InvoiceData = response.data.invoicePageList.invoices;
        let simpleAutoCompleteList = new Array();
        if (InvoiceData.length > 0 && InvoiceData != null) {
          InvoiceData.map((inv) => {
            let simpleItemBean = {
              code: inv.code,
              description: "",
            };
            simpleAutoCompleteList.push(simpleItemBean);
          });
        }
        this.setState({
          invoicePageListForAutoCompleteList: simpleAutoCompleteList,
        });
      }
    };

    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>CreditMemo Number Starts With</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="creditMemoNumberStartsWith"
                  name="creditMemoNumberStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.creditMemoNumberStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>CreditMemo Number Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="creditMemoNumberContains"
                  name="creditMemoNumberContains"
                  onChange={this.onChange}
                  value={searchCriteria.creditMemoNumberContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Status</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="creditMemoStatus"
                  value={searchCriteria.creditMemoStatus}
                >
                  <option value={""}></option>
                  <option value={"O"}>Open</option>
                  <option value={"A"}>Approved</option>
                  <option value={"U"}>UnApproved</option>
                  <option value={"F"}>Finished</option>
                  <option value={"P"}>Partially Closed</option>
                  <option value={"C"}>Partially Used && Approved</option>
                  <option value={"X"}>Cancelled</option>
                </FormControl>
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Customer</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="customerCode"
                  name="customerCode"
                  onChange={this.customerCodeOnChange}
                  value={searchCriteria.customerCode}
                  lookupRequired={true}
                  lookupHandler={this.state.customerLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.customerPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteList}
                  showAutoCompleteList={this.state.showAutoCompleteCustomerList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>invoice Number</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="invoiceNumber"
                  name="invoiceNumber"
                  onChange={this.invoiceOnChange}
                  value={searchCriteria.invoiceNumber}
                  lookupRequired={true}
                  lookupHandler={this.state.invoiceLookupHandler}
                  enterKeyEventHandler={this.invoiceEnterKeyEvent}
                  showCriteriaDialog={true}
                  autoCompleteListData={
                    this.state.invoicePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayInvoiceAutoCompleteList}
                  showAutoCompleteList={this.state.showAutoCompleteInvoiceList}
                />
              </Col>
            </Row>
            <Row className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
